import { AnalyticsProvider } from "@codat/analytics";
import { OrchardProvider } from "@codat/orchard-ui";
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";

import config from "config";

import styles from "./App.module.css";
import AppRouter from "./AppRouter";

const checkIsPersisted = (event: PageTransitionEvent) => {
  if (event.persisted) {
    location.reload();
  }
};

function App() {
  useEffect(() => {
    window.addEventListener("pageshow", checkIsPersisted);

    return window.removeEventListener("pageshow", checkIsPersisted);
  }, []);

  return (
    <div className={styles.app}>
      <OrchardProvider appId="app-portal">
        <BrowserRouter>
          <CompatRouter>
            <AnalyticsProvider
              config={{
                apiKey: config.AMPLITUDE_API_KEY,
                appName: "",
                mode:
                  config.ENVIRONMENT === "Integration"
                    ? "development"
                    : "production",
              }}
            >
              <AppRouter />
            </AnalyticsProvider>
          </CompatRouter>
        </BrowserRouter>
      </OrchardProvider>
    </div>
  );
}

export default App;
